import { ANTD_TABLE_ENTITIES } from "../../../components/AntdTable/AntdTable.constants";
import { ReviewTypes } from "../../ManageContract/constants";
import { DASHBOARD_FEATURES } from "../../vscDashboard/constants";

export const adminManagementTabs = [
  {
    text: "Contract Review",
    disabled: false,
  },
  {
    text: DASHBOARD_FEATURES.CLAUSE_CHECK,
    disabled: false,
  },
];

export const manageContractTabs = [
  {
    text: ReviewTypes.PENDING_REVIEW,
    disabled: false,
  },
  {
    text: ReviewTypes.COMPLETED_REVIEW,
    disabled: false,
  },
];

export const userManagementTabs = [
  {
    text: "Users",
    disabled: false,
    typographyProps: {},
    count: 10,
    entity: ANTD_TABLE_ENTITIES.USER_MANAGEMENT,
  },
  {
    text: "Requests",
    disabled: false,
    count: 10,
    entity: ANTD_TABLE_ENTITIES.USER_MANAGEMENT_REQUESTS,
  },
  {
    text: "Rejected",
    disabled: false,
    count: 10,
    entity: ANTD_TABLE_ENTITIES.USER_MANAGEMENT_REJECTED,
  },
];

const displayNames = {
  COMMITED_BUFFER: "Commited Buffer",
  PRODUCTIVITY_IMPROVEMENTS: "Productivity Improvements",
  SLA_PENALTY: "SLA Penalty/Earn back",
  VOLUME_DISCOUNTS: "Volume Discounts",
};

const ruleNames = {
  MIN_BENCH_POOL: "Min Bench Pool",
  MIN_CONTRACT_TERM: "Min Contract Term",
  PRODUCTIVITY_IMPROVEMENT: "Productivity Improvement (%)",
  MIN_CREDIT_CAP: "Min Credit Cap/Penalty",
  MIN_TOTAL_SPENDS: "Min Total Spends",
  MIN_DISCOUNT: "Min Discount",
};
export const ruleUnits = {
  PERCENT: "%",
  DOLLAR: "$",
  MONTHS: "months",
};

export const PromptManagementValidations = {
  CONTRACT_REVIEW: {
    [displayNames.COMMITED_BUFFER]: {
      rules: {
        [ruleNames.MIN_BENCH_POOL]: {
          unit: ruleUnits.PERCENT,
          max: 50,
          min: 0,
        },
      },
    },
    [displayNames.PRODUCTIVITY_IMPROVEMENTS]: {
      rules: {
        [ruleNames.MIN_CONTRACT_TERM]: {
          unit: ruleUnits.MONTHS,
          max: 120,
          min: 1,
        },
        [ruleNames.PRODUCTIVITY_IMPROVEMENT]: {
          unit: ruleUnits.PERCENT,
          max: 100,
          min: 1,
        },
      },
    },
    [displayNames.SLA_PENALTY]: {
      rules: {
        [ruleNames.MIN_CREDIT_CAP]: {
          unit: ruleUnits.PERCENT,
          max: 100,
          min: 1,
        },
      },
    },
    [displayNames.VOLUME_DISCOUNTS]: {
      rules: {
        [ruleNames.MIN_TOTAL_SPENDS]: {
          unit: ruleUnits.DOLLAR,
          max: 100000000,
          min: 1,
        },
        [ruleNames.MIN_DISCOUNT]: {
          unit: ruleUnits.PERCENT,
          max: 100,
          min: 1,
        },
      },
    },
  },
};

export const TABLE_TAB = "table_tab";

export const SYNC_CONTRACTS_ERRORS = {
  dest_drive_folder: "Please select a destination drive folder",
  vertical: "Please select a vertical",
  year: "Please select a year",
  src_drive_folder: "Please select a source drive folder",
  drive_links_same: "Source and Destination Drive Folder cannot be same",
};
